import { render, staticRenderFns } from "./SaleSortMenu.vue?vue&type=template&id=e7261b6a&scoped=true&"
import script from "./SaleSortMenu.vue?vue&type=script&lang=js&"
export * from "./SaleSortMenu.vue?vue&type=script&lang=js&"
import style0 from "./SaleSortMenu.vue?vue&type=style&index=0&id=e7261b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7261b6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
